module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-bold-rounded-CPL6VNRV.eot?81561c67697fc09f050b035ad6a3f660";